import { render } from "./RegisterPage.vue?vue&type=template&id=e08b83d0&scoped=true"
import script from "./RegisterPage.vue?vue&type=script&lang=js"
export * from "./RegisterPage.vue?vue&type=script&lang=js"

import "./RegisterPage.vue?vue&type=style&index=0&id=e08b83d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e08b83d0"]])

export default __exports__